export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 9.82,
        "transcript": "Elpeci caciryaraci apa'urlumta-llu au͡gkut piciryarait nalluyagutessiyaangvakaitki.",
        "translation": "Because they're forgetting your pratices, and our grandfathers' traditions back then."
    },
    "2": {
        "startTime": 10.9,
        "endTime": 15.44,
        "transcript": "Qununaqsaaquq man'a, kallagnarqenricaaquq piciryararput.",
        "translation": "This is precious, our culture should be [?]."
    },
    "3": {
        "startTime": 15.635,
        "endTime": 17.945,
        "transcript": "Qununarqeqap'iartuq.",
        "translation": "It's very precious."
    },
    "4": {
        "startTime": 18.075,
        "endTime": 28.685,
        "transcript": "Taumek picirluta, una-llu arcaqerlunuk cing'arpuk ayagyuat makut maani tangerqaasqelluki, cellangcaqaasqelluki.",
        "translation": "For that reason, he and I especially push for you to look at and teach lessons to these young people here."
    },
    "5": {
        "startTime": 29.355,
        "endTime": 34.395,
        "transcript": "Waten-llu nunacuarni, nani piciatun",
        "translation": "And in village like this, anywhere"
    },
    "6": {
        "startTime": 34.46,
        "endTime": 41.27,
        "transcript": "Man'a piciryararput Yup'igtaq qessakevkenaku, nasvagluku makunun ayagyuanun.",
        "translation": "Do not reject our Yup'ik culture, but share it with these young people."
    },
    "7": {
        "startTime": 41.4,
        "endTime": 48.4,
        "transcript": "Tangvagluteng aturlaqumta wangkuta qessakevkenaku maligtengciqaitkut.",
        "translation": "If they watch us practicing it without rejecting it, they will follow suit."
    },
    "8": {
        "startTime": 48.835,
        "endTime": 55.065,
        "transcript": "Kass'amirtatun mat'utun ingluartessiyaagpek'naki pinarqai.",
        "translation": "We must keep them from leaning toward these Western ways."
    },
    "9": {
        "startTime": 55.235,
        "endTime": 61.745,
        "transcript": "Wangkutnun taug͡aam atauq man'a maani Yugtun piciryaraq eglerutellerkaa.",
        "translation": "It is upon us to continue the Yup'ik culture here."
    },
    "10": {
        "startTime": 61.745,
        "endTime": 67.385,
        "transcript": "Wangkuta aturyunrilkumteggu makut maani ayagyuat aturyugngaitaat.",
        "translation": "If we don't want to practice it, these young people here won't want to practice it."
    },
    "11": {
        "startTime": 67.6,
        "endTime": 77.82,
        "transcript": "Tangvagluci tau͡gaam, tangvagluta-llu wangkuta Yup'igtaq man'a ciumuuluku qessakevkenaku tengrukluku pikumta nutaan tuani maligtengciqaitkut.",
        "translation": "Only if they watch you, if they watch us put our Yup'ik culture first, without rejecting it, and being enthused about it, only then will they follow suit."
    },
    "12": {
        "startTime": 78.025,
        "endTime": 86.22,
        "transcript": "Qanaatenrilengramteki, \"Usuuq, yuralrianun agi. Usuuq, atulrianun niicugniyartua.\"",
        "translation": "We don't need to say to them, \"Hey you, go to the Yup'ik dancing. Hey you, go listen to them singing.\""
    },
    "13": {
        "startTime": 86.22,
        "endTime": 93.88,
        "transcript": "Tuaten arca qanaaviiqnata. Wangkutnek nangerrluta, aqumluta pingkumta maligtengciqaitkut.",
        "translation": "Let's stop saying that. If we stand and go sit of our own accord, they will follow suit."
    },
    "14": {
        "startTime": 94.265,
        "endTime": 97.215,
        "transcript": "Taumek tua-i qanqe'rtua.",
        "translation": "That's what I have to say."
    },
    "15": {
        "startTime": 97.585,
        "endTime": 101.995,
        "transcript": "I just related to the community here and the rest of the group",
        "translation": "I just related to the community here and the rest of the group"
    },
    "16": {
        "startTime": 102.255,
        "endTime": 115.415,
        "transcript": "Is the Coastal Yukon Villages Association have directed Mr. Troll and I to be a project director to have an activity like this during this year.",
        "translation": "Is the Coastal Yukon Villages Association have directed Mr. Troll and I to be a project director to have an activity like this during this year."
    },
    "17": {
        "startTime": 116.44,
        "endTime": 127.65,
        "transcript": "We were glad to be the directors and getting the support from the donors to have this activity available and made tonight.",
        "translation": "We were glad to be the directors and getting the support from the donors to have this activity available and made tonight."
    },
    "18": {
        "startTime": 130.08,
        "endTime": 140.49,
        "transcript": "One of most things that we're glad about, we wanted to preserve our culture, both the language and the culture itself.",
        "translation": "One of most things that we're glad about, we wanted to preserve our culture, both the language and the culture itself."
    },
    "19": {
        "startTime": 141.65,
        "endTime": 153.8,
        "transcript": "We want to show these kids, the young ones especially, through our actions we can show them that we really mean to preserve our language and culture.",
        "translation": "We want to show these kids, the young ones especially, through our actions we can show them that we really mean to preserve our language and culture."
    },
    "20": {
        "startTime": 154.05,
        "endTime": 157.38,
        "transcript": "If we do it ourselves, they will follow us.",
        "translation": "If we do it ourselves, they will follow us."
    },
    "21": {
        "startTime": 157.38,
        "endTime": 164.03,
        "transcript": "We don't have to tell them to go to the Eskimo dance, to go sing the song that the people are singing.",
        "translation": "We don't have to tell them to go to the Eskimo dance, to go sing the song that the people are singing."
    },
    "22": {
        "startTime": 164.03,
        "endTime": 171.03,
        "transcript": "If we as elders and young men do it, they will follow us. We don't have to tell them. We don't have to push them.",
        "translation": "If we as elders and young men do it, they will follow us. We don't have to tell them. We don't have to push them."
    },
    "23": {
        "startTime": 171.035,
        "endTime": 178.195,
        "transcript": "If we ourselves show interest in preserving our culture, they will follow us too. Thank you.",
        "translation": "If we ourselves show interest in preserving our culture, they will follow us too. Thank you."
    },
    "24": {
        "startTime": 185.34,
        "endTime": 188.46,
        "transcript": "Stebbins, Mr. Francis Rivers.",
        "translation": "Stebbins, Mr. Francis Rivers."
    },
    "25": {
        "startTime": 189.665,
        "endTime": 191.125,
        "transcript": "Oh, Benny.",
        "translation": "Oh, Benny"
    },
    "26": {
        "startTime": 193.9,
        "endTime": 196.19,
        "transcript": "Benny Ketcha.",
        "translation": "Benny Ketcha."
    },
    "27": {
        "startTime": 198.18,
        "endTime": 203.55,
        "transcript": "Wanigga tangrarpecia wani. Tapramek taillruunga.",
        "translation": "You see me here. I came from Stebbins."
    },
    "28": {
        "startTime": 203.55,
        "endTime": 210.52,
        "transcript": "Wanigga ilaitni ak'allarrarni elitaqngatarpecia.",
        "translation": "Now, some of you older ones seem to recognize me."
    },
    "29": {
        "startTime": 213.13,
        "endTime": 219.17,
        "transcript": "Now, I am thankful that we see each other.",
        "translation": "Now, I am thankful that we see each other."
    },
    "30": {
        "startTime": 219.565,
        "endTime": 225.705,
        "transcript": "Quyanarqeq'apiartuq. Ak'all[artarnek] cali ak'allat piciuluteng.",
        "translation": "I am very thankful. And the ancient things are true."
    },
    "31": {
        "startTime": 226.77,
        "endTime": 234.71,
        "transcript": "Imumi wani ak'a tan'gurraullemni qaneryaranek niicimallruunga.",
        "translation": "Long ago when I was a boy, I heard a lot of traditional wisdom."
    },
    "32": {
        "startTime": 235.065,
        "endTime": 238.955,
        "transcript": "Miklua tamaani ayagnillruunga, atairullua-llu.",
        "translation": "I started back when I was small, and I lost my father."
    },
    "33": {
        "startTime": 238.955,
        "endTime": 245.105,
        "transcript": "Ak'arraq ataka tuqullruluni tayima. Pingyurivailegma ataka tuqullruuq.",
        "translation": "My father had already been dead for a while. My father died before I was active."
    },
    "34": {
        "startTime": 245.135,
        "endTime": 248.155,
        "transcript": "Aanama tau͡gaam nautellruanga.",
        "translation": "My mother raised me instead."
    },
    "35": {
        "startTime": 250.65,
        "endTime": 256.46,
        "transcript": "Cali wanigga makut kinguqliput",
        "translation": "Also, our descendants here now"
    },
    "36": {
        "startTime": 257.175,
        "endTime": 261.515,
        "transcript": "Mat'umek wani ak'allat piciryaraatnek",
        "translation": "These old ways"
    },
    "37": {
        "startTime": 268.08,
        "endTime": 272.52,
        "transcript": "Ak'a qaneryaraitnek elicimasqumayaaqluki.",
        "translation": "I want them to learn their ancient traditional wisdom."
    },
    "38": {
        "startTime": 274.675,
        "endTime": 281.795,
        "transcript": "Makut ak'allat qaneryaraat tamasqumanricaaqluku",
        "translation": "I don't want these ancient pieces of wisdom to disappear"
    },
    "39": {
        "startTime": 284.07,
        "endTime": 288.7,
        "transcript": "Catairuskumta tamalriatun ayuqeciqngan.",
        "translation": "Because when we're gone, it will disappear."
    },
    "40": {
        "startTime": 289.41,
        "endTime": 296.65,
        "transcript": "Wanigga-am wani atakurpak quyanarqellriit qanaalriit.",
        "translation": "Now, the people that have been speaking this evening have made me feel thankful."
    },
    "41": {
        "startTime": 296.955,
        "endTime": 302.295,
        "transcript": "Mat'umek cali maa-i anglaniyaurtellriakut tamamta nunani.",
        "translation": "Now, all of us villages have started enjoying this."
    },
    "42": {
        "startTime": 302.92,
        "endTime": 306.65,
        "transcript": "Quyanarqelartuq cakneq tangrrutaqamta.",
        "translation": "When we see each other, it makes me feel very thankful."
    },
    "43": {
        "startTime": 306.84,
        "endTime": 314.98,
        "transcript": "Makut cali kinguqlimta tayima catairuskumta tamana tayima eneqakciqaat cali.",
        "translation": "When we're gone, these descendats of ours will probably remember that."
    },
    "44": {
        "startTime": 315.405,
        "endTime": 321.885,
        "transcript": "Tamarcessngailngataat tamana makut umyuarteqellriit kinguqlimta.",
        "translation": "It seems that our mindful descendants will not let them disappear."
    },
    "45": {
        "startTime": 323.09,
        "endTime": 328.4,
        "transcript": "Ak'anun-llu wani ilait wangkuta yuugurngaicugnarqukut.",
        "translation": "Some of us probably won't live very long either."
    },
    "46": {
        "startTime": 328.412,
        "endTime": 341.924,
        "transcript": "Tayima-tuq camek wani navguatmek wani, navguatmek makut kiinguqliput nutaraq",
        "translation": "I hope that our descendants, with their new ways that bring desctruction"
    },
    "47": {
        "startTime": 342.087,
        "endTime": 349.137,
        "transcript": "Ak'allat piciryarait-tuq tayima malirqengkilitki.",
        "translation": "I hope they start going after the old traditions."
    },
    "48": {
        "startTime": 352.519,
        "endTime": 357.944,
        "transcript": "Anarullua wii Kass'atun qanerciigalmiunga.",
        "translation": "I cannot speak too much English either."
    },
    "49": {
        "startTime": 360.888,
        "endTime": 364.063,
        "transcript": "Qanssiyaagciigatua Kass'acetun.",
        "translation": "I can't speak too much English."
    },
    "50": {
        "startTime": 366.244,
        "endTime": 377.294,
        "transcript": "Wanigga-am, wanigga-m quyalrianga caknek ukut wani taivkaatkut",
        "translation": "Now, I am very thankful that these people had us come"
    },
    "51": {
        "startTime": 377.301,
        "endTime": 387.601,
        "transcript": "Asaacaryarmiut cali, Tuqsugmiut cali tangerrluki, cali qau͡gkut Negeqlirmek pilriit cali tangerrluki.",
        "translation": "Mountain Village too, and looking at Toksook Bay, and looking at the place they call St. Mary's."
    },
    "52": {
        "startTime": 388.695,
        "endTime": 395.358,
        "transcript": "Ilakqapiaralriatun waten ayuqlirtukut. Quyanaqluni-am cakneq.",
        "translation": "It's like we are close-knit now. I am very thankful for that."
    },
    "53": {
        "startTime": 397.645,
        "endTime": 402.483,
        "transcript": "Camek anagullua qanerciigalmiunga.",
        "translation": "I cannot speak too excessively either."
    },
    "54": {
        "startTime": 411.258,
        "endTime": 420.133,
        "transcript": "He has echoed what has been said earlier by the other leaders that were up here talking.",
        "translation": "He has echoed what has been said earlier by the other leaders that were up here talking."
    },
    "55": {
        "startTime": 420.989,
        "endTime": 432.939,
        "transcript": "Umyugamteggun tangrruarturpegnaki ilaput maani uitalriit, caput, ilaput tangvagluki, tangvakapigcelluki",
        "translation": "Not just imagning seeing our relatives who are our, our relatives, looking at our relatives, having them see them"
    },
    "56": {
        "startTime": 432.958,
        "endTime": 439.458,
        "transcript": "Taitaa ukut uukucirluta Ayaacaryarmiut tangvagcilluki.",
        "translation": "The people from Mountain Village brought them here through this to have us see them."
    },
    "57": {
        "startTime": 439.465,
        "endTime": 443.102,
        "transcript": "Tamatumek tau͡ga quyatengqertua wii.",
        "translation": "That is what I'm thankful for."
    },
    "58": {
        "startTime": 443.552,
        "endTime": 459.602,
        "transcript": "Tau͡gaam tau͡ga waten wanigga imkut civuliamta imkut atullrat au͡gna umyugamteńi, umyugamni keyianeng uitarrlainatuuq.",
        "translation": "But now the things that our ancestors experienced like this always stays in my mind."
    },
    "59": {
        "startTime": 460.984,
        "endTime": 467.734,
        "transcript": "Ilakutqapiggluteng ilakellengnaarat civuliamta imkut.",
        "translation": "Our ancestors were tight knit with the people around them."
    },
    "60": {
        "startTime": 467.941,
        "endTime": 471.403,
        "transcript": "Cakneq naklekulluteng-llu.",
        "translation": "They were also very compassionate towards each other."
    },
    "61": {
        "startTime": 471.641,
        "endTime": 477.641,
        "transcript": "Waten wanigga wangkuta piniartukut:",
        "translation": "Let us do this:"
    },
    "62": {
        "startTime": 477.773,
        "endTime": 486.973,
        "transcript": "Au͡gkut qaneryaraqegtaaraat, civumni qanellret qaneryarait pegtenritniaraput",
        "translation": "Let's not abandon those wonder pieces of wisdom, the wisdom of the ones who spoke before me"
    },
    "63": {
        "startTime": 486.98,
        "endTime": 493.492,
        "transcript": "Qang'a-llu maavet, qang'a-llu ankumta peggluki.",
        "translation": "Let's not abandon them, whether here, or whether we go out."
    },
    "64": {
        "startTime": 493.505,
        "endTime": 498.405,
        "transcript": "Tegumiaqerkauluki cuullemta taktacirraatun.",
        "translation": "We must hold them for the duration of our short lives."
    },
    "65": {
        "startTime": 498.674,
        "endTime": 506.124,
        "transcript": "Tegumiaqluki pegtarkauvkenaki, kingunitengramta-llu pegtevkenaki.",
        "translation": "Let's hold on to them and not abandon them, and don't abandon them even if we go back home."
    },
    "66": {
        "startTime": 506.268,
        "endTime": 515.681,
        "transcript": "Makunun wangkuta irniaramteńun cali atungnaqureniaraput tamakut kenekluki, cagyuunaki.",
        "translation": "Let us try to use them toward our children here out of love, not lose them."
    },
    "67": {
        "startTime": 516.693,
        "endTime": 529.381,
        "transcript": "Elluarrluteng tamakut teggenret imkut ayagyugameggni qanaataqkaitkut naklekulluta ilakulluta pisqelluta.",
        "translation": "Those elders spoke correct things to the young ones, telling us to be a compassionate community."
    },
    "68": {
        "startTime": 529.544,
        "endTime": 539.756,
        "transcript": "Ilaput-llu inerqur[luki], inerqurluta cali ilaput-gguq piciqenrilkaitnek picilirluki qanaayaqunata.",
        "translation": "They also admonished our peers, they also admonished us against speaking accusations about what those around us wouldn't do."
    },
    "69": {
        "startTime": 540.519,
        "endTime": 550.269,
        "transcript": "Cali waten camun nall'aruteqerluta pikumta, assinrilngurmek aturtiinun",
        "translation": "Also, if we come across something like this, one who does bad things"
    },
    "70": {
        "startTime": 550.576,
        "endTime": 558.488,
        "transcript": "Tau͡gaggun-gguq tangvagpegnaku, assillrakun tau͡gaam tangvagniararput, tangvagniarput.",
        "translation": "They said we should not look at him through that, but to look at him through his good characteristics."
    },
    "71": {
        "startTime": 559.901,
        "endTime": 569.326,
        "transcript": "Waten wanigga imkut civuliaput elluarrluteng pisqumaillruut ayagyugameggneng.",
        "translation": "Our ancestors here wanted their young people to do well like this."
    },
    "72": {
        "startTime": 569.407,
        "endTime": 577.382,
        "transcript": "Wangkuta cali atungnaqureluki piniaraput tamakut civuliamta imkut piciryarallrat.",
        "translation": "Let us also try to practice those, our ancestors' traditions."
    },
    "73": {
        "startTime": 577.638,
        "endTime": 591.038,
        "transcript": "Makunun irniaramteńun atungnaqureluki, qang'a-llu irniaqenrilengramteki. Makunun ayagyugaat tungiitnun cali atungnaqureluki piniartukut.",
        "translation": "Let us try to practice them with our children, and even if they're not our children. Let's try to practice them with these young people."
    },
    "74": {
        "startTime": 591.282,
        "endTime": 600.632,
        "transcript": "Maa-i man'a quyanerqelria, waten taivkallerput maavet tangrrutesqelluta.",
        "translation": "I am thankful for this, that we were brought here to see each other."
    },
    "75": {
        "startTime": 600.643,
        "endTime": 612.018,
        "transcript": "Ilaput tungelquput-llu tangaasqelluki tamatum iluani ilukegcinarqeqap'iareluni cakneq tamana tau͡gatnallerput",
        "translation": "It gives us great joy to do that, to see our relatives, our close friends, during that time"
    },
    "76": {
        "startTime": 612.037,
        "endTime": 621.112,
        "transcript": "Ilaput tangrraqluki, umyugamteggun tangrraurtu'rpegnaki tangpiggluki tangerrluki.",
        "translation": "Seeing our relatives, not just imagining them, but seeing them in person."
    },
    "77": {
        "startTime": 621.506,
        "endTime": 632.918,
        "transcript": "Cali waten una wanigga atu[?]: ukisqaqengnaqureluku Agayutmek pituniartukut.",
        "translation": "This is also a [?good] thing to do: let us only rely on God for help."
    },
    "78": {
        "startTime": 632.931,
        "endTime": 641.369,
        "transcript": "Ukisqaqengnaqerrlainarluku piyuutemteńek niitenrilengraitkut.",
        "translation": "Let us only rely on him for help, even if he doesn't give us everything we want."
    },
    "79": {
        "startTime": 641.607,
        "endTime": 647.232,
        "transcript": "Niiqurainarniaraakut atam niitenriqaarluta-llu.",
        "translation": "He will listen to us after not granting our request."
    },
    "80": {
        "startTime": 647.751,
        "endTime": 653.713,
        "transcript": "Piyuutvut tauna wangkutnun taiqurainarniaraa atam.",
        "translation": "You see, he will eventually bring us what we want."
    },
    "81": {
        "startTime": 653.726,
        "endTime": 664.676,
        "transcript": "Cali makut wangkuta kingunemteńun ayakumta tamakuneng au͡gkut qaneryaraqegtaa'rneng au͡gkut civumi qanaallerneng",
        "translation": "Also, when we go back to our homes, those wonderful pieces of traditional wisdom from those who spoke first"
    },
    "82": {
        "startTime": 664.695,
        "endTime": 673.745,
        "transcript": "Qaneryaraqegtaaraat tamakut makunun mikelngurramteńun wangkuta egmirqurluki piniaraput.",
        "translation": "Let us pass on those wondeful pieces of wisdom to our little children."
    },
    "83": {
        "startTime": 673.752,
        "endTime": 677.902,
        "transcript": "Taringyuitaitkut waten Cup'igtun qanengramta.",
        "translation": "Though don't understand us when we speak Cup'ik."
    },
    "84": {
        "startTime": 678.234,
        "endTime": 688.621,
        "transcript": "Tau͡gaam wangkuta tau͡gaten pingraata, taringyuilengraata, aulukengnatugarkaugaput makut mikelnguput irniarraput.",
        "translation": "But though they do that, though they don't understand, we must try to take care of our children."
    },
    "85": {
        "startTime": 688.634,
        "endTime": 692.459,
        "transcript": "Tau͡g qinuitellerkaatnun tekisngaqulluki.",
        "translation": "Teach them to the point where they're peaceful."
    },
    "86": {
        "startTime": 693.028,
        "endTime": 701.14,
        "transcript": "Tau͡ga tamatumeng quyatengqertua wii ukuneng taivkartemteńeng.",
        "translation": "I am thankful to these who had us come for that."
    },
    "87": {
        "startTime": 707.991,
        "endTime": 718.116,
        "transcript": "...St. Mary's, one of my jobs that I miss very dearly, is that I got to yell at the kids to be quiet. So you kids be quiet while I'm talking, alright?",
        "translation": "...St. Mary's, one of my jobs that I miss very dearly, is that I got to yell at the kids to be quiet. So you kids be quiet while I'm talking, alright?"
    },
    "88": {
        "startTime": 718.822,
        "endTime": 724.635,
        "transcript": "I want all of you to know that this is only half of what this festival is about.",
        "translation": "I want all of you to know that this is only half of what this festival is about."
    },
    "89": {
        "startTime": 725.622,
        "endTime": 734.772,
        "transcript": "One of the important that we're doing and that you've talked about tonight as elders, that it's important to preserve your culture and pass it along to your children.",
        "translation": "One of the important that we're doing and that you've talked about tonight as elders, that it's important to preserve your culture and pass it along to your children."
    },
    "90": {
        "startTime": 734.891,
        "endTime": 747.791,
        "transcript": "Well, these three days, you have an excellent opportunity, not only for dancing, but we have some artifacts and things that were collected by Sheldon Jackson 100 years ago from this area.",
        "translation": "Well, these three days, you have an excellent opportunity, not only for dancing, but we have some artifacts and things that were collected by Sheldon Jackson 100 years ago from this area."
    },
    "91": {
        "startTime": 748.16,
        "endTime": 753.848,
        "transcript": "So it is very important, we want you elders to go up and see it.",
        "translation": "So it is very important, we want you elders to go up and see it."
    },
    "92": {
        "startTime": 753.986,
        "endTime": 760.298,
        "transcript": "If you know things about it, we want you to talk and talk, and tell your children about this.",
        "translation": "If you know things about it, we want you to talk and talk, and tell your children about this."
    },
    "93": {
        "startTime": 760.311,
        "endTime": 764.149,
        "transcript": "These are things that you may remember from when you were kids.",
        "translation": "These are things that you may remember from when you were kids."
    },
    "94": {
        "startTime": 764.399,
        "endTime": 772.024,
        "transcript": "The things you're going to see up there are very, very interesting, and I think many of your children are not going to understand what they were for.",
        "translation": "The things you're going to see up there are very, very interesting, and I think many of your children are not going to understand what they were for."
    },
    "95": {
        "startTime": 772.03,
        "endTime": 776.33,
        "transcript": "So it is very important for you to talk with them and see it.",
        "translation": "So it is very important for you to talk with them and see it."
    },
    "96": {
        "startTime": 776.349,
        "endTime": 782.799,
        "transcript": "The exhibit will be open tomorrow at 9 o'clock, and will go until the potluck dinner at 3 o'clock.",
        "translation": "The exhibit will be open tomorrow at 9 o'clock, and will go until the potluck dinner at 3 o'clock."
    },
    "97": {
        "startTime": 782.806,
        "endTime": 786.118,
        "transcript": "Then it'll be open from Sunday until we start dancing.",
        "translation": "Then it'll be open from Sunday until we start dancing."
    },
    "98": {
        "startTime": 786.356,
        "endTime": 792.806,
        "transcript": "Now, I have a long list of thank-yous, but I'm going to do that tomorrow night and maybe the night after, so we can get right to dancing.",
        "translation": "Now, I have a long list of thank-yous, but I'm going to do that tomorrow night and maybe the night after, so we can get right to dancing."
    },
    "99": {
        "startTime": 792.813,
        "endTime": 798.488,
        "transcript": "But one of the people I want to introduce and to at least acknowledge three, four people at this time.",
        "translation": "But one of the people I want to introduce and to at least acknowledge three, four people at this time."
    },
    "100": {
        "startTime": 798.619,
        "endTime": 808.682,
        "transcript": "One is the gentleman who's sitting out back here in the corner. He looks like Kenny Rogers. That is Peter Corey. He is the curator of the Sheldon Jackson Museum in Sitka.",
        "translation": "One is the gentleman who's sitting out back here in the corner. He looks like Kenny Rogers. That is Peter Corey. He is the curator of the Sheldon Jackson Museum in Sitka."
    },
    "101": {
        "startTime": 808.694,
        "endTime": 814.244,
        "transcript": "He has allowed all of these old things to come out here for you to see for the next three days.",
        "translation": "He has allowed all of these old things to come out here for you to see for the next three days."
    },
    "102": {
        "startTime": 814.251,
        "endTime": 822.363,
        "transcript": "When you go and see him tomorrow, if you know things, talk to him. Let him know things about the things that are there if you have information.",
        "translation": "When you go and see him tomorrow, if you know things, talk to him. Let him know things about the things that are there if you have information."
    },
    "103": {
        "startTime": 822.539,
        "endTime": 831.226,
        "transcript": "The other person I want to thank is Wassilie Evan. He went down to Sitka with me and helped select the artifacts that are there.",
        "translation": "The other person I want to thank is Wassilie Evan. He went down to Sitka with me and helped select the artifacts that are there."
    },
    "104": {
        "startTime": 831.239,
        "endTime": 837.889,
        "transcript": "The other person is Willie Beans who's kind of hiding back up there. But he also went down to Sitka to help pick...",
        "translation": "The other person is Willie Beans who's kind of hiding back up there. But he also went down to Sitka to help pick..."
    },
    "105": {
        "startTime": 837.908,
        "endTime": 845.671,
        "transcript": "...maani ayagyuat waten mikellriit nalqigulluki cat kangiitnek tamakut tangllerpeci nallunrilkuvciki.",
        "translation": "...expalin to the young people, the children here, about the significance of what you see if you know them."
    },
    "106": {
        "startTime": 845.683,
        "endTime": 853.796,
        "transcript": "Tuani aturyugyaaqamceci nalqigtesqelluki tamakut calinguat Yup'igtaat.",
        "translation": "We want to use you there to explain those handmade Yup'ik things."
    },
    "107": {
        "startTime": 854.271,
        "endTime": 858.833,
        "transcript": "Cali cetamanek yugnek quyayugyaaquq...",
        "translation": "He also wants to thank four people..."
    },
    "108": {
        "startTime": 859.259,
        "endTime": 865.296,
        "transcript": "...enirturallritnek tailluta waniwa tangvagciqaci. Paqeskiciki unuaqu.",
        "translation": "...you will see what they pointed to and that we brought. Please go see them tomorrow."
    },
    "109": {
        "startTime": 865.309,
        "endTime": 870.246,
        "transcript": "Tau͡gaam aturyugamceci nallunrilkuvciki tamakut kangiit.",
        "translation": "But we want to use you if you know their significance."
    },
    "110": {
        "startTime": 872.621,
        "endTime": 882.033,
        "transcript": "We've got the reporters from the following: Lower Yukon School District newsletter Joyce Copper, Mountain Village High School journalist...",
        "translation": "We've got the reporters from the following: Lower Yukon School District newsletter Joyce Copper, Mountain Village High School journalist..."
    },
    "111": {
        "startTime": 882.046,
        "endTime": 887.009,
        "transcript": "́́...movies, Mountain VIllage High School photograph, James Parker.",
        "translation": "́́́...movies, Mountain VIllage High School photograph, James Parker."
    },
    "112": {
        "startTime": 887.021,
        "endTime": 891.896,
        "transcript": "Alaska Maganize [?right here], Danny [?] Edward Beans.",
        "translation": "Alaska Maganize [?right here], Danny [?] Edward Beans."
    },
    "113": {
        "startTime": 892.402,
        "endTime": 897.777,
        "transcript": "Peter Corey, McKinney Rogers of the Sheldon Jackson Museum.",
        "translation": "Peter Corey, McKinney Rogers of the Sheldon Jackson Museum."
    },
    "114": {
        "startTime": 898.508,
        "endTime": 900.808,
        "transcript": "...having Eskimo dancing.",
        "translation": "...having Eskimo dancing."
    },
    "115": {
        "startTime": 901.59,
        "endTime": 905.952,
        "transcript": "And for all you people that's going to be using the bathrooms back there...",
        "translation": "And for all you people that's going to be using the bathrooms back there..."
    },
    "116": {
        "startTime": 906.765,
        "endTime": 917.69,
        "transcript": "And also, all you tobacco chewers and snuff chewers, use those number 10 cans that are provided. Don't use those pop cans, they spill too easy.",
        "translation": "And also, all you tobacco chewers and snuff chewers, use those number 10 cans that are provided. Don't use those pop cans, they spill too easy."
    },
    "117": {
        "startTime": 917.709,
        "endTime": 922.596,
        "transcript": "And before you go out, pick up your cans and throw them in the trash can. I don't want to have to pick up your spit.",
        "translation": "And before you go out, pick up your cans and throw them in the trash can. I don't want to have to pick up your spit."
    },
    "118": {
        "startTime": 923.996,
        "endTime": 925.934,
        "transcript": "...in here, please.",
        "translation": "...in here, please."
    },
    "119": {
        "startTime": 928.184,
        "endTime": 938.797,
        "transcript": "And also transportation person is in charge is Mr. Demitry George, to the airport and within the local community.",
        "translation": "And also transportation person is in charge is Mr. Demitry George, to the airport and within the local community."
    },
    "120": {
        "startTime": 939.434,
        "endTime": 946.959,
        "transcript": "And for safety factor, see these exit signs just in case there's a fire.",
        "translation": "And for safety factor, see these exit signs just in case there's a fire."
    },
    "121": {
        "startTime": 946.965,
        "endTime": 949.34,
        "transcript": "Please don't panic.",
        "translation": "Please don't panic."
    },
    "122": {
        "startTime": 949.684,
        "endTime": 956.746,
        "transcript": "There's double doors back here to go out, there's the door where you came in, and this one here.",
        "translation": "There's double doors back here to go out, there's the door where you came in, and this one here."
    },
    "123": {
        "startTime": 958.134,
        "endTime": 961.509,
        "transcript": "Use the city telephone amani.",
        "translation": "Use the city telephone over there."
    },
    "124": {
        "startTime": 962.378,
        "endTime": 965.115,
        "transcript": "Qanelriinaryunritua.",
        "translation": "I don't want to speak for too long."
    },
    "125": {
        "startTime": 965.128,
        "endTime": 971.015,
        "transcript": "Yugtun mumigtenrilengraata. Makut maani mikelnguaraat taringetuut kinguput.",
        "translation": "They don't need to be translated to Yup'ik. These children, our descendants, understand."
    },
    "126": {
        "startTime": 971.028,
        "endTime": 973.853,
        "transcript": "Nayangangnaurtukut. Arenqiarutukut.",
        "translation": "Let's start dancing. We're getting restless."
    },
    "127": {
        "startTime": 980.609,
        "endTime": 986.947,
        "transcript": "Waniwa atukurpak ukut nunat, 12 villages, malrugnek aturtaar[ciqut].",
        "translation": "This evening, these villages, 12 villages, will sing two songs each."
    }
};